import React from 'react';
import TracingOptions from "./TracingOptions";
import PageSorting from "./PageSorting";
import {useAppSelector} from "../../../store/hooks";

const PageHeader = () => {
    const authUser = useAppSelector(state => state.auth.authUser)
    return (
        <>
            <div className="text-sm w-full md:w-auto justify-between md:justify-between flex mb-4">
                <TracingOptions />
            </div>
            {authUser?.isAdmin && <div className="text-sm w-full md:w-auto justify-between md:justify-end flex mb-4">
                <PageSorting />
            </div>}
        </>
    );
};

export default PageHeader;